.notice {
    color: red;
    text-align: center;
    margin: 10px 0;
}
.title {
    margin-top: 25px;
    border-bottom: solid 1px #cccccc;
}

.content {
    margin: 10px 0 10px 0;
}
